import { SiteFeatureCollection, SiteNavigatorResponse } from "@models/site";

export const fetchSites = async (
	apiKey: string,
	apiEndpoint: string,
): Promise<SiteNavigatorResponse> => {
	const resp = await _createRequest(
		apiKey,
		apiEndpoint,
		"/v1/access-request/sites",
	);
	const data = (await resp.json()) as {
		sites: SiteFeatureCollection;
		organizationID: string;
	};
	return data;
};

export const fetchDocument = async (
	documentID: string,
	apiKey: string,
	apiEndpoint: string,
): Promise<Response> => {
	return _createRequest(
		apiKey,
		apiEndpoint,
		`/v1/access-request/document?documentID=${documentID}`,
	);
};

export const postAccessRequest = async (
	apiEndpoint: string,
	apiKey: string,
	data: object,
): Promise<Response> => {
	if (!apiKey) throw new Error("No API key found");

	try {
		const resp = await _createRequest(
			apiKey,
			apiEndpoint,
			"/v1/access-request",
			"POST",
			JSON.stringify(data),
		);
		return resp;
	} catch (error) {
		console.error(error);
		throw new Error(error);
	}
};

export function createHeaders(apiKey: string) {
	const headers = new Headers();
	headers.append("x-api-key", apiKey);
	headers.append("Content-Type", "application/json");
	return headers;
}

const _createRequest = async (
	apiKey: string,
	apiEndpoint: string,
	path: string,
	method?: "POST" | "GET" | "PUT" | "DELETE",
	body?: string,
): Promise<Response> | undefined => {
	if (!apiKey) throw new Error("No API key found");

	// if endpoint schema is not set, add it
	const scheme = window.location.protocol === "https:" ? "https" : "http";
	const url = `${scheme}://${apiEndpoint}${path}`;
	// create a header with the api key
	const headers = createHeaders(apiKey);

	// makes request with the api key
	return await fetch(url, {
		method: method ? method : "GET",
		headers: headers,
		body: body ? body : undefined,
	});
};
